'use es6';

import { createTracker } from 'usage-tracker-public';
import events from 'MeetingsLib/events.yaml';
import { MEETINGS_APP_NAME } from 'MeetingsBase/constants/strings';
var DEFAULT_LOCALE = 'en';
var tracker = null;
var screen = 'public';
export function initializeMeetingsLibTracker(email, portalId, embedded, locale) {
  screen = embedded ? 'embedded' : 'public';
  tracker = createTracker({
    events: events,
    properties: {
      namespace: MEETINGS_APP_NAME,
      email: email,
      hubId: portalId,
      lang: locale || window.I18n ? window.I18n.locale : DEFAULT_LOCALE,
      screen: screen
    }
  });
  return tracker;
}
export function track(eventKey) {
  var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (tracker) {
    tracker.track(eventKey, Object.assign({
      screen: screen
    }, eventProperties));
  }
}